<template>
  <div>
    <div class="container text m-y-3">
      <h3 class= "m-y-2 titular-bajo">Documentos</h3>
      <p class="intro">
        Se pone a disposición de la ciudadanía los siguientes documentos en
        torno al Programa Interinstitucional de Especialidad en Soberanías
        Alimentarias y Gestión de Incidencia Local Estratégica (PIES-AGILES).
      </p>
    </div>

    <div class="container m-y-3">
      <div class="grid-descargas">
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiijp_PnXy6SPXMnug?e=zMbAjd"
          descripcion="Malla Curricular"
          nombre="Malla Curricular"
          imagen_lap="img/portadas/malla-curricular.jpg"
          imagen_cel="img/portadas/malla-curricular-cel.jpg"

        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiij-t1tVpDfqRImZz"
          descripcion="Informe Financiero"
          nombre="Informe Financiero Final"
          imagen_lap="img/portadas/informe-financiero.jpg"
          imagen_cel="img/portadas/informe-financiero-cel.jpg"
        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiijsL0JggfKnxF-Dz"
          descripcion="Programa de Articulaciones Interinstitucionales e Interseccionales"
          nombre="Articulaciones"
          imagen_lap="img/portadas/programa-articulacion.jpg"
          imagen_cel="img/portadas/programa-articulacion-cel.jpg"
        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiij6ZJZ8w09yXCFIU"
          descripcion="Seminario de Investigación Acción Participativa"
          nombre="Facilitadores"
          imagen_lap="img/portadas/facilitadores-temas.jpg"
          imagen_cel="img/portadas/facilitadores-temas-cel.jpg"
        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiijx5AyfPWL9MnNv3"
          descripcion="Número de jóvenes en proceso de formación y grado de avance"
          nombre="Alumnos"
          imagen_lap="img/portadas/numero-de-jovenes.jpg"
          imagen_cel="img/portadas/numero-de-jovenes-cel.jpg"
        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiijlrcyM2rJyuFFd3"
          descripcion="Informe técnico de proyecto"
          nombre="Informe Técnico"
          imagen_lap="img/portadas/informe-tecnico.jpg"
          imagen_cel="img/portadas/informe-tecnico-cel.jpg"

        />
        <LinkPDF
          class="m-b-1"
          link="https://1drv.ms/b/s!Aubg4PSdkCoiij0fyOA6eiKtytIN"
          descripcion="Informe Técnico de la Plataforma de Pies Ágiles"
          nombre="Informe de la plataforma"
          imagen_lap="img/portadas/presentacion-plataforma.jpg"
          imagen_cel="img/portadas/presentacion-plataforma-cel.jpg"
        />



      </div>
    </div>
  </div>
</template>

<script>
import LinkPDF from "@/components/base/LinkPDF.vue";

export default {
  name: "Documentos",
  components: {
    LinkPDF,
  },
  mounted() {
    if (document.getElementById("initial-loader")) {
      document.getElementById("initial-loader").remove();
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
  },
};
</script>

<style scoped lang="scss">
.titulo{
  font-size: 36px;
}
.descargas {
  position: relative;
  .descarga-todo {
    border: 1px solid #187ff8;
    border-radius: 5px;
    color: #187ff8;
    font-size: 14px;
    position: absolute;
    top: 0;
    right: 0;
    transition: color 0.27s ease-in-out;
    padding: 5px 30px 5px 10px;
    .icono {
      color: #187ff8;
      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 100%;
      text-align: center;
      transition: margin-top 0.27s ease-in-out;
      position: absolute;
      right: 0;
      font-size: 26px;
      line-height: 21px;
    }
  }
  @media (max-width: 420px) {
    p {
      max-width: calc(100% - 160px);
    }
  }
}

@media (min-width: map-get($media-queries-limit, "mobile")) {
  .grid-descargas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $gap * 2;
  }
}
</style>

